import { useEffect, useRef } from 'react'
import Icon from './Icon.jsx'

/**
 * Dialog über der Seite.
 *
 * Auf dem Handy fährt er als Blatt von unten herein, auf größeren Schirmen
 * steht er mittig. Escape und ein Tipp auf den Hintergrund schließen ihn;
 * solange er offen ist, scrollt die Seite dahinter nicht mit.
 */
export default function Dialog({ titel, untertitel, symbol, beiSchliessen, children }) {
  const kasten = useRef(null)

  useEffect(() => {
    function beiTaste(ereignis) {
      if (ereignis.key === 'Escape') beiSchliessen()
    }
    document.addEventListener('keydown', beiTaste)

    const vorher = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    // Erstes Eingabefeld bekommt den Fokus — sonst tippt man ins Leere.
    kasten.current?.querySelector('input, textarea, select')?.focus()

    return () => {
      document.removeEventListener('keydown', beiTaste)
      document.body.style.overflow = vorher
    }
  }, [beiSchliessen])

  return (
    <div
      className="hintergrund"
      onMouseDown={(e) => {
        // Nur schließen, wenn der Hintergrund selbst getroffen wurde — nicht
        // wenn im Dialog eine Auswahl über den Rand hinaus gezogen wurde.
        if (e.target === e.currentTarget) beiSchliessen()
      }}
    >
      <div className="dialog" role="dialog" aria-modal="true" aria-label={titel} ref={kasten}>
        <header className="dialog__kopf">
          <div>
            <h2>
              {symbol && <Icon name={symbol} groesse={18} />} {titel}
            </h2>
            {untertitel && <p className="hinweis">{untertitel}</p>}
          </div>
          <button
            className="knopf knopf--geist knopf--symbol knopf--klein"
            type="button"
            onClick={beiSchliessen}
          >
            <Icon name="kreuz" />
            <span className="nur-vorlesen">Schließen</span>
          </button>
        </header>

        <div className="dialog__inhalt">{children}</div>
      </div>
    </div>
  )
}
